import { render, staticRenderFns } from "./RuleItemPickerDialog.vue?vue&type=template&id=607f3407"
import script from "./RuleItemPickerDialog.vue?vue&type=script&lang=ts"
export * from "./RuleItemPickerDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports